import {
  nextRarity,
  resolveMaterialButtonState,
  type MaterialButtonState,
} from "../systems/ModuleMerge.js";
import { resolveFusionButtonState } from "../systems/ModuleFusion.js";
import type { ModuleRarity } from "../modules/ProjectileModule.js";

/** PascalCase View 셸 대신 합성/융합 UI 선택 상태 판정을 소유하는 Phaser-free helper. */
export type { MaterialButtonState };

export interface MergeButtonRow {
  readonly instanceId: string;
  readonly definitionId: string;
  readonly rarity: ModuleRarity;
}

export interface FusionButtonRow {
  readonly instanceId: string;
  readonly footprintId: string;
}

export function nextMergeRarity(rarity: ModuleRarity): ModuleRarity | null {
  return nextRarity(rarity);
}

export function resolveMergeMaterialButtonState(
  selectedIds: readonly string[],
  rows: readonly MergeButtonRow[],
  targetId: string,
): MaterialButtonState {
  return resolveMaterialButtonState(selectedIds, rows, targetId);
}

export function resolveFusionMaterialButtonState(
  selectedIds: readonly string[],
  rows: readonly FusionButtonRow[],
  targetId: string,
): MaterialButtonState {
  return resolveFusionButtonState(selectedIds, rows, targetId);
}
